// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  states: []
}

const logs = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_DATA':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    default:
      return { ...state }
  }
}
export default logs
